@use "styles" as *;

.me-pager-item {
  display: block;
  padding: space(2, 4);
  border: 1px solid $color-gray-200;
  border-left-width: 0.5px;
  border-right-width: 0.5px;
  color: $color-primary;
  font-weight: $font-weight-semi-bold;

  .me-link__label {
    color: $color-primary;
  }

  &:first-child {
    border-left-width: 1px;
  }

  &:last-child {
    border-right-width: 1px;
  }

  &--active {
    background-color: $color-primary;
    border-color: $color-primary;
    color: $color-background;

    .me-link__label {
      color: $color-background;
    }
  }

  &--disabled:hover {
    cursor: not-allowed;
  }
}
